/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: 1_lRcjfh8CEO
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicButtonNav.module.css"; // plasmic-import: 1_lRcjfh8CEO/css
import image9ARcsVGaJAiQd from "./images/image9.svg"; // plasmic-import: ARcsVGaJAiQD/picture

createPlasmicElementProxy;

export const PlasmicButtonNav__VariantProps = new Array(
  "shape",
  "status",
  "color"
);

export const PlasmicButtonNav__ArgProps = new Array(
  "iconForButton",
  "onClick",
  "disabled",
  "name"
);

const $$ = {};

function PlasmicButtonNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "shape",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.shape
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__nJ1Nn",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_greyOne]: hasVariant($state, "color", "greyOne"),
          [sty.rootcolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.rootcolor_transparentBg]: hasVariant(
            $state,
            "color",
            "transparentBg"
          ),
          [sty.rootcolor_white]: hasVariant($state, "color", "white"),
          [sty.rootshape_fullRounding]: hasVariant(
            $state,
            "shape",
            "fullRounding"
          ),
          [sty.rootshape_globalRounding]: hasVariant(
            $state,
            "shape",
            "globalRounding"
          ),
          [sty.rootstatus_disabled]: hasVariant($state, "status", "disabled")
        }
      )}
      disabled={(() => {
        try {
          return $props.disabled;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      name={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      type={"button"}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img___1VGbs)}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={{
              src: image9ARcsVGaJAiQd,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.iconForButton
      })}
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonNav__ArgProps,
          internalVariantPropNames: PlasmicButtonNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButtonNav";
  } else {
    func.displayName = `PlasmicButtonNav.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonNav = Object.assign(
  // Top-level PlasmicButtonNav renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicButtonNav
    internalVariantProps: PlasmicButtonNav__VariantProps,
    internalArgProps: PlasmicButtonNav__ArgProps
  }
);

export default PlasmicButtonNav;
/* prettier-ignore-end */
